import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/site/Motion";

export default function Eden() {
  return (
    <section className="px-6 pb-24 sm:px-10 md:pb-32 lg:px-16" data-testid="home-eden">
      <div className="mx-auto max-w-7xl">
        <Reveal y={40}>
          <div className="grid items-center gap-10 rounded-[2rem] border border-stone-border bg-white/70 p-8 md:p-12 lg:grid-cols-12">
            <div className="relative mb-8 lg:col-span-5">
              <div className="absolute -left-4 -top-4 h-full w-full blob-3 bg-sand/40" aria-hidden="true" />
              <div className="blob-3 relative aspect-[5/4] overflow-hidden shadow-[0_25px_50px_-25px_rgba(43,58,48,0.4)]">
                <img
                  src="/photos/eden-calin.webp"
                  alt="Moment de complicité couché dans l'herbe avec Eden, le cheval"
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 hover:scale-105"
                  style={{ objectPosition: "50% 45%" }}
                  data-testid="eden-image"
                />
              </div>
              <div className="absolute -bottom-8 -right-2 w-32 rotate-3 overflow-hidden rounded-2xl border-4 border-cream shadow-xl md:w-40" data-testid="eden-photo-secondary">
                <img
                  src="/photos/eden-pre.webp"
                  alt="Eden, le cheval, au pré"
                  loading="lazy"
                  className="aspect-square w-full object-cover"
                  style={{ objectPosition: "50% 72%" }}
                />
              </div>
              <div className="absolute -bottom-4 left-6 whitespace-nowrap rounded-full border border-stone-border bg-cream/95 px-5 py-2.5 shadow-lg backdrop-blur-md" data-testid="eden-caption">
                <span className="font-serif text-sm italic text-ink">Eden, un partenaire en or</span>
              </div>
            </div>
            <div className="lg:col-span-7 lg:col-start-6">
              <p className="overline-label">Et aussi…</p>
              <h2 className="mt-4 font-serif text-3xl font-medium leading-[1.15] tracking-tight text-ink sm:text-4xl">
                L'équithérapie, avec <span className="italic text-terracotta">mon cheval Eden.</span>
              </h2>
              <p className="mt-5 max-w-xl text-base leading-relaxed text-ink/70" data-testid="eden-text">
                Selon votre situation, l'accompagnement peut aussi se dérouler
                auprès d'Eden, mon cheval — un partenaire doux et apaisant, lui
                aussi au service du lien. Nous en parlons ensemble lors du
                premier échange pour voir ce qui conviendra le mieux à votre
                famille.
              </p>
              <Link
                to="/contact"
                className="mt-7 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.18em] text-terracotta transition-[gap] duration-300 hover:gap-3.5"
                data-testid="eden-cta"
              >
                En parler ensemble <ArrowRight size={15} />
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
